<template>
  <div class="about">
    <div style="text-align:left;width:100%">
      <el-button type="success" @click="$router.go(-1)">back</el-button>
    </div>
    <Header />
    <Intro msg="Zszen John" />
    <!-- <h1>This is an about page</h1> -->
  </div>
</template>

<script>
import Header from "../components/header.vue";
import Intro from "../components/Intro.vue";

export default {
  name: "about",
  data() {
    return {
      head_icon: "./img/head.png"
    };
  },
  components: {
    Header,
    Intro
  }
};
</script>

<style>
.head120 {
  max-width: 120px;
}
</style>
